import { getRequest } from '@/core';
import { deviations } from '@/requests';

export default async function getActionTypesRequest(id) {
	let url = deviations.getActionTypesPath(id);
	let response = await getRequest(url);
	return response;
}
